export { default as RateCalculator } from './RateCalculator';



// WEBPACK FOOTER //
// ./src/modules/rate-calculator/pages/index.js